var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){return _vm.submitUpdateAsinInfo(null)}}},[_vm._t("default",function(){return [_c('span',{staticClass:"el-icon-refresh",staticStyle:{"cursor":"pointer"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }